import styled from "styled-components"

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;

  min-height: 100%;
`
